import { PricingByCardConfig } from "../pricing/components/pricing-by-card";

// Prices of omni documents are entered manually, never derived from the positions.
export const omniPricingByCardConfig: PricingByCardConfig = {
  usePositionsSwitch: false,
  activeSwitch: true,
};
